import { useIsInstaller } from 'src/auth/hooks/useIsInstaller';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

export const useProductSummaryAvailable = () => {
  const isInstaler = useIsInstaller();
  return useHasFeatureFlag('ProductSummaryView') && isInstaler;
};
